export const decideJourneyType = (props) => {
  const { value, formSubmissionPayload, memberContext } = props.dataObject;
  const { setFormSubmissionPayload } = props.functionObject;

  // to delete hardshipJourneyType from formSubmissionPayload if
  //  no option is selected so that dependent fields can be hidden/shown.
  if (value.length === 0) {
    setFormSubmissionPayload((prevPayload) => {
      const updatedPayload = { ...prevPayload };
      const { hardshipJourneyType } = updatedPayload;
      if (hardshipJourneyType) {
        delete updatedPayload.hardshipJourneyType;
      }
      updatedPayload.elemId = null;
      return updatedPayload;
    });
    return;
  }

  const selectedCards = memberContext
    .filter((info) => value.includes(info.accountToken))
    .map((info) => {
      const { accountToken } = info;
      const { lineOfBusinessType } = info.product.accountTypes;
      return { accountToken, lineOfBusinessType };
    });

  if (selectedCards.some((card) => card.lineOfBusinessType === 'ConsumerCard')
    && selectedCards.some((card) => card.lineOfBusinessType === 'CompanyCard')) {
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      elemId: null,
      hardshipJourneyType: 'ConsumerAndSbs',
      accountToken: selectedCards[0]?.accountToken,
    });
  } else if (selectedCards.some((card) => card.lineOfBusinessType === 'ConsumerCard')) {
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      elemId: null,
      hardshipJourneyType: 'Consumer',
      accountToken: selectedCards[0]?.accountToken,
    });
  } else if (selectedCards.some((card) => card.lineOfBusinessType === 'CompanyCard')) {
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      elemId: null,
      hardshipJourneyType: 'Sbs',
      accountToken: selectedCards[0]?.accountToken,
    });
  }
};

export const populateHardshipSelectOptionLabel = (props) => {
  const { e } = props.dataObject;
  const { setFormSubmissionPayload, fieldId } = props;
  const { options } = e.target;
  const selectedOption = options[options.selectedIndex];
  const label = selectedOption ? selectedOption.innerText : '';

  setFormSubmissionPayload((prev) => ({ ...prev, elemId: null, [`${fieldId}_selected`]: label }));
};
